import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import { useTheme } from '@mui/material/styles';
import { MatchDetailsCompetitor } from './MatchDetailsCompetitor';
import { useMatch } from '../MatchProvider';

export function MatchDetailsScoreline() {
  const { competitor1, competitor2 } = useMatch();
  const showStatus = !!competitor1 && !!competitor2;
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        borderBottom: `1px solid ${theme.palette.primary.dark}`,
        justifyContent: 'space-between',
        p: '8px 12px',
        gap: '8px',
      }}
    >
      {!!competitor1 && (
        <MatchDetailsCompetitor
          showStatus={showStatus}
          competitor={competitor1}
          sx={{ pr: 4 }}
        />
      )}
      <Divider orientation="vertical" flexItem sx={{ ml: '-16px' }} />
      {!!competitor2 && (
        <MatchDetailsCompetitor
          showStatus={showStatus}
          competitor={competitor2}
          sx={{ flexDirection: 'row-reverse' }}
          innerSx={{ flexDirection: 'row-reverse' }}
        />
      )}
    </Box>
  );
}
